import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  FORMULARY_FEATURE_KEY,
  FormularyPartialState,
  FormularyState,
} from './formulary.reducer';

export const getFormularyState = createFeatureSelector<FormularyState>(
  FORMULARY_FEATURE_KEY,
);

export const getFormularyLoaded = createSelector(
  getFormularyState,
  (state: FormularyState) => state.loaded,
);

export const getFormularyError = createSelector(
  getFormularyState,
  (state: FormularyState) => state.error,
);

export const getFormularyDrugList = createSelector(
  getFormularyState,
  (state: FormularyState) => state.data,
);

export const getOtherInformation = createSelector(
  getFormularyState,
  (state: FormularyState) => state.otherFormularyInfo,
);
